import Modal from '../../../node_modules/vue-js-modal/src/components/Modal.vue'
import Dialog from '../../../node_modules/vue-js-modal/src/components/Dialog.vue'
import PluginCore from '../../../node_modules/vue-js-modal/src/PluginCore.js'

const Plugin = {
  install (Vue, options = {}) {
    if (Vue.prototype.$modal) {
      return
    }

    // PluginCore is an arrow factory; `new` throws (package dist works only because Babel rewrites it).
    const plugin = PluginCore(Vue, options)

    Object.defineProperty(Vue.prototype, '$modal', {
      get: function () {
        const caller = this
        if (caller instanceof Vue) {
          const root = caller.$root

          if (!plugin.context.root) {
            plugin.setDynamicModalContainer(root)
          }
        }

        return plugin
      }
    })

    Vue.component(plugin.context.componentName, Modal)

    if (options.dialog) {
      const componentName = options.dialogComponentName || 'VDialog'
      Vue.component(componentName, Dialog)
    }
  }
}

export { Modal, Dialog }
export const version = '__VERSION__'
export default Plugin
